import { lazyOpenBizChatSidePane } from 'owa-bizchat-shared';
import { type LocalizedString } from 'owa-localize';
import type { OpenBizChatSidePaneParams } from 'owa-bizchat-types';
import { isFeatureEnabled } from 'owa-feature-flags';

export type OpenChatPaneOptions = {
    params?: Partial<OpenBizChatSidePaneParams>;
    promptText: LocalizedString;
};

/**
 * Opens the Copilot chat side pane with the specified prompt text and DAB source attribution.
 */
export const openChatPane = ({ params, promptText }: OpenChatPaneOptions): void => {
    lazyOpenBizChatSidePane.importAndExecute({
        ...params,
        isNewChat: true,
        promptText,
        source: isFeatureEnabled('copilot-dab-bottom-right')
            ? 'CopilotDabBottomRightSUA'
            : 'CopilotDabRibbonSUA',
    });
};
